export default function Header({ children, size = 'lg', className = '' }) {
  const fontSize = {
    sm: 'sm',
    md: 'md',
    lg: 'lg',
    xl: 'xl',
    '2xl': '2xl',
    '3xl': '3xl',
    '4xl': '4xl',
    '5xl': '5xl',
    '6xl': '6xl',
    '7xl': '7xl',
    '8xl': '8xl',
    '9xl': '9xl' 
  }[size] || 'lg';

  return (
    <h1 className={`text-${fontSize} font-medium ${className}`}>
      {children}
    </h1>
  );
}
